import React, { useEffect, useState } from 'react'
import Profile from "../assets/images/user-profile.jpg"
import { useBranding } from '../context/BrandingContext';
import axios from 'axios';
import { API_URL, getCookie, getHeaders } from '../helper/commonApi';
import Loader from '../components/loader';
import ChangePasswordModal from '../components/Modals/ChangePasswordModal';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaArrowLeftLong } from 'react-icons/fa6';

const ProfileComponents = () => {
    const { colors, portalID } = useBranding();
    const navigate = useNavigate();
    const userId = localStorage.getItem('_register_GRE_LOGIN_userId');

    const [user, setUser] = useState({});
    const [loading, setLoading] = useState(false)

    const [openPassModal, setOpenPassModal] = useState(false);
    const [purchase, setPurchase] = useState([]);


    const dateObj = purchase?.purchases?.length > 0
        ? new Date(purchase.purchases[0].purchase_date)
        : new Date();

    // Extract values
    const year = dateObj?.getFullYear();
    const month = dateObj?.getMonth() + 1; // months are 0-based
    const day = dateObj?.getDate();
    const formatted = `${year}.${month}.${day}`;


    useEffect(() => {
        const jwtToken = getCookie('_GRE_JWT_TOKEN');

        if (!userId || !jwtToken) {
            localStorage.clear();
            document.cookie = "_GRE_JWT_TOKEN=; max-age=0; path=/;";
            navigate('/')
            return;
        }

        getUserDetail();
        getPurchaseDetails();
    }, [])



    const getUserDetail = async () => {
        setLoading(true);
        try {
            const res = await axios.post(`${API_URL}/user-details`, {
                portal_id: portalID,
                user_id: userId
            }, {
                headers: getHeaders()
            });

            if (res.status === 200) {
                setUser(res?.data?.data)
                setLoading(false);
                // toast.success(res.data.message)
            } else {
                console.error("Failed to fetch dashboard");
                setLoading(false);
            }
        } catch (err) {
            toast.error(err)
            console.error("Error fetching dashboard:", err);
            setLoading(false);

        }
    }

    const getPurchaseDetails = async () => {
        try {
            const res = await axios.post(`${API_URL}/purchase-details`, {
                portal_id: portalID,
                user_id: userId
            }, {
                headers: getHeaders()
            });

            if (res.status === 200) {
                // console.log(res?.data?.data);
                setPurchase(res?.data?.data)
                // toast.success(res.data.message)
            } else {
                console.error("Failed to fetch dashboard");
            }
        } catch (err) {
            toast.error(err)
            console.error("Error fetching dashboard:", err);

        }
    }

    return (
        <div>

            {loading ? <Loader /> :

                <div style={{ padding: "0 15px" }}>
                    {/* Back to Dashboard button */}
                    <div className="container" style={{ marginTop: "20px", maxWidth: "900px" }}>
                        <button
                            onClick={() => navigate("/dashboard")}
                            style={{
                                padding: "10px 16px",
                                background: colors.primaryColor,
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                                cursor: "pointer",
                                fontWeight: 500,
                                display: "flex",
                                alignItems: "center",
                                gap: "8px"
                            }}
                        >
                            <span style={{ display: "flex" }}><FaArrowLeftLong /></span><span>Back to Dashboard</span>
                        </button>
                    </div>
                    <div class="profile-container" style={{ background: colors.popupBg }}>
                        <div class="profile-card">
                            <h1>Profile</h1>
                            <div class="profile-content">
                                <img src={Profile} alt="Profile" class="profile-img" />
                                <div class="profile-details">
                                    <p><strong>Full Name</strong><br /><span style={{ textTransform: 'capitalize' }}>{user?.full_name}</span></p>
                                    <p><strong>Email</strong><br />{user?.email_address}</p>
                                    {/* <p><strong>Contact</strong><br />+1 123 4567 890</p>
                        <p><strong>Address</strong><br />Funchal, Portugal</p> */}
                                </div>
                            </div>
                            <div class="action-buttons">
                                <button className='btn dark' onClick={() => setOpenPassModal(true)}>Change Password</button>
                                {/* <button className='btn dark'>Edit Profile</button> */}
                            </div>
                            <div class="plan-box" style={{ background: colors?.primaryColor }}>
                                <div class="">
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                    }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle cx="12" cy="12" r="12" fill="white" />
                                            <path d="M13 3L6 13h5v8l7-10h-5z" fill={colors.primaryColor} />
                                        </svg>
                                        <div>{purchase?.purchases?.length > 0 ? purchase?.purchases?.[0]?.package_name : "Free Plan"}</div>
                                    </div>
                                    <small>Purchased on: {formatted}</small>
                                </div>
                                <button onClick={() => { navigate('/pricing') }} class="btn dark">Upgrade Plan</button>
                            </div>
                        </div>
                    </div>
                </div>

            }


            {openPassModal &&
                <ChangePasswordModal
                    onClose={() => setOpenPassModal(false)}
                    userId={userId}
                />
            }
        </div>
    )
}

export default ProfileComponents